export default function Field({ label, required, error, children, hint, className = '' }) {
  return (
    <div className={className}>
      {label && (
        <label className="label">
          {label} {required && <span className="text-danger-500">*</span>}
        </label>
      )}
      {children}
      {error && <p className="mt-1 text-xs font-medium text-danger-600">{error}</p>}
      {hint && !error && <p className="mt-1 text-xs text-content-subtle">{hint}</p>}
    </div>
  );
}